<div mat-dialog-title>Update Contact Info</div>
<div mat-dialog-content>
  <formly-form [model]="model" [fields]="formlyFields"></formly-form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-flat-button [color]="'primary'" [mat-dialog-close]="model">Save</button>
</div>
